import { useTonWallet, useTonConnectUI } from "@tonconnect/ui-react";
import { type FC, useCallback } from "react";
import { Button } from "@telegram-apps/telegram-ui";
import "./Airdrop.css";
import { useI18n } from "../../utils/i18n/I18nProvider";

export const Airdrop: FC = () => {
  const wallet = useTonWallet();
  const [tonConnectUI] = useTonConnectUI();
  const { t } = useI18n();

  const handleWalletAction = useCallback(async () => {
    if (wallet) {
      // Disconnect wallet if already connected
      await tonConnectUI.disconnect();
    } else {
      // Connect wallet if not connected
      await tonConnectUI.openModal();
    }
  }, [wallet, tonConnectUI]);

  const getButtonText = () => {
    if (wallet) {
      return t("toolkit.airdrop.editWallet");
    }
    return t("toolkit.airdrop.addWallet");
  };

  return (
    <div className="airdrop-container">
      <div className="airdrop-header">
        <h1 className="airdrop-title">{t("toolkit.airdrop.title")}</h1>
        <p className="airdrop-subtitle">
          {t("toolkit.airdrop.subtitle")}
          <span className="airdrop-subtitle--minimal-withdrawal">
            &nbsp;20 USDT
          </span>
        </p>
      </div>

      {wallet && (
        <div className="wallet-connected-container">
          <div className="wallet-connected-info">
            <p className="wallet-connected-label">
              {t("toolkit.airdrop.connectedWallet")}
            </p>
            <p className="wallet-connected-name">
              {"appName" in wallet ? wallet.appName : "Wallet"}
            </p>
          </div>
          <div className="wallet-connected-avatar">
            {"imageUrl" in wallet && (
              <img
                src={wallet.imageUrl}
                alt="Wallet icon"
                className="wallet-avatar-image"
              />
            )}
          </div>
        </div>
      )}

      <div className="airdrop-action">
        <Button
          onClick={handleWalletAction}
          size="l"
          stretched
          className="airdrop-button"
        >
          {getButtonText()}
        </Button>
      </div>
    </div>
  );
};
